/* Verbatim port of the AI-engine icon helpers from
 * service/review/index.html (~860-874).
 *
 * PARAMETERIZED: the original read the global `API_BASE` (a
 * location.port/location.protocol-derived constant computed at ~3507 in the
 * old file, well after this function is defined — it works there only
 * because API_BASE is assigned before any render call happens). That global
 * doesn't exist in a module context, so `apiBase` is threaded through as an
 * explicit extra parameter per the F1 porting rules. Appended after the
 * pre-existing parameters (not prepended as a first `state`-style param —
 * documented deviation in the F1 report) so the call site reads naturally:
 * modelIcon(name, apiBase).
 *
 * F4 item 3 — `modelBadge(name, sz, apiBase)` DELETED (dead code, zero
 * callers, grep-confirmed): views/ai.ts's F3 conversion (see that file's
 * doc comment, "SELF-CORRECTION") already replaced its one call site with
 * `modelIcon()` + a native lit `html` `<img>` template, specifically to
 * avoid needing `unsafeHTML` for a string-returning helper — modelBadge was
 * left in place at the time only "for symmetry" with wave C's other
 * deletions, not because anything still called it. `esc()` (lib/format.ts)
 * was modelBadge's only reason to be imported here; it is NOT deleted from
 * format.ts itself, since it has several other real, necessary consumers
 * documented in that file's F3c END-STATE comment (favForDomain() in this
 * same module family, views/markdown.ts, views/dossier.ts, derive/
 * entity.ts, ui/graph.ts, ui/runModal.ts) — none of them
 * route through icons.ts, so format.ts's inventory comment needed no
 * change.
 */

/* AI-engine icons (served from /ai-models). Google's SGE "AI Overview" and
   "AI Mode" share the Google mark. Returns '' when no icon matches. */
export const MODEL_ICON: Record<string, string> = { chatgpt:'chatgpt', gemini:'gemini', copilot:'copilot',
  claude:'claude', grok:'grok', perplexity:'perplexity',
  'ai overview':'google', 'ai mode':'google', 'google ai overview':'google',
  bard:'gemini', bingai:'copilot', sge:'google', googleaimode:'google' };

export function modelIcon(name: string | null | undefined, apiBase: string): string {
  const k = (name||'').toLowerCase().trim();
  const f = MODEL_ICON[k] || (k.includes('google')?'google':k.includes('chatgpt')||k.includes('openai')?'chatgpt':'');
  // ?v bumps when the icon assets change — /ai-models has no Cache-Control, so
  // without this browsers keep serving heuristically-cached (stale) logos.
  return f ? `${apiBase}/ai-models/${f}.png?v=2` : '';
}
